import { NavLink } from 'react-router-dom';
import { SEGMENTED_TRACK, segmentedItem } from '../ui';

const TABS = [
  { to: 'overview', label: 'Overview' },
  { to: 'tasks', label: 'Tasks' },
  { to: 'whiteboard', label: 'Whiteboard' },
  { to: 'edit', label: 'Edit' },
] as const;

/**
 * Links rather than ARIA tabs. Each section is a real URL, so these navigate --
 * `role="tablist"` would promise arrow-key behaviour the router does not
 * implement, and would lose middle-click and "open in new tab". NavLink sets
 * `aria-current="page"` on the active one for free.
 *
 * The skin comes from ui.tsx now rather than being written here. This bar, the
 * Projects view toggle and the dashboard's due window were three drawings of
 * the same control; they are one drawing used three times.
 */
export function ProjectTabs() {
  return (
    <nav aria-label="Project sections" className={SEGMENTED_TRACK}>
      {TABS.map((tab) => (
        <NavLink key={tab.to} to={tab.to} className={({ isActive }) => segmentedItem(isActive)}>
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
